export const stringsKey = "ScheduledTemplateList";
export const englishStrings = {
	templateListErrorMessage: "Failed to load template list!",
	title: "Scheduled Batch Messages",
};
